module.exports = __webpack_public_path__ + "static/img/top_title_bg.57c0b6d6.png";